export const UserRoles = {
	INTERNAL: 1,
	ADMINISTRATIVE: 2,
	TECHNICAL: 3,
	SALE_ROLE: 34
};

export const Roles = Object.freeze({
	ADMIN:1,
	SUPPORT:2,
	INTERNAL:3,
	RESELLER:4,
	CUSTOMER:5,
	PLACE:6,
	BOX:7,
	DEVICE:8,
	COMPANY:9,
	SHOP:10,
	TERMINAL:11
});

/**
 * @returns {import('@fortawesome/fontawesome-svg-core').IconProp}
 */
export const getIconForNode = ( node ) => {
	
	if( node.hasOwnProperty( "disabled" ) ) {
		return ["fas" , "eye-slash"];
	}
	
	if( node && node.role ) {
		switch( node.role ) {
			case Roles.ADMIN: //fall through;
			case Roles.SUPPORT: //fall through;
			case Roles.INTERNAL: //fall through;
			case Roles.RESELLER: return ["fas" , "industry"];
			case Roles.CUSTOMER: return ["fas" , "shop"];
			case Roles.COMPANY: //fall through
			case Roles.SHOP:
			case Roles.PLACE: return ["fas" , "globe-americas"];
			case Roles.BOX: return ["fas" , "archive"];
			case Roles.TERMINAL: return ["fas" , "display"];
			case Roles.DEVICE: //return ["fas" , "home"];
				try {
					if( node.name.includes("BNR") || node.name.includes("SCR") ) {
						return ['fas', 'money-bill'];
					} else if ( node.name.includes("CLS") || node.name.includes("MDB") ) {
						return ['fas', 'coins'];
					} else if ( node.name.includes("VIPS") ) {
						return ['fas', 'money-check'];
					} else if ( node.name.includes("VirtualDevice") ) {
						return ['fas', 'desktop'];
					}
				} catch( error ) {
					return ["fas" , "home"];
				}
				break;
			default : return ["fas" , "home"];
		}
	}
	
	return ["fas" , "home"];
};
